import { forwardRef } from 'react'
import type { Message } from '../types'
import { SavingsCard } from './SavingsCard'

interface Props {
  messages: Message[]
  onCta?: (label: string) => void
  ctaDisabled?: boolean
}

export const MessageList = forwardRef<HTMLDivElement, Props>(function MessageList({ messages, onCta, ctaDisabled }, ref) {
  // data-clarity-mask="true": fortæl Microsoft Clarity at maskere alt tekst
  // i denne node + descendants. Chat-beskedlisten echo'er bruger-svar (postnr,
  // alder, telefon) tilbage som user-bubbles og bot kan adressere brugeren
  // ved fornavn ("Hej Viggo, hvor bor du?"). Clarity's default-masking dækker
  // <input>-elementer men ikke fri tekst i divs — derfor explicit her.
  return (
    <div className="chat-scroll" ref={ref} data-clarity-mask="true">
      {messages.map((msg) => {
        if (msg.type === 'typing') {
          return (
            <div key={msg.key} className="msg-typing">
              <div className="msg-bot-avatar">
                <img src="/fiona-avatar-final.png" alt="" />
              </div>
              <div className="typing-bubble">
                <span className="typing-dot" />
                <span className="typing-dot" />
                <span className="typing-dot" />
              </div>
            </div>
          )
        }
        if (msg.type === 'bot') {
          return (
            <div key={msg.key} className="msg-bot">
              <div className="msg-bot-avatar">
                <img src="/fiona-avatar-final.png" alt="" />
              </div>
              <div className="msg-bot-bubble">{msg.text}</div>
            </div>
          )
        }
        if (msg.type === 'savings') {
          return (
            <div key={msg.key} className="msg-savings">
              <SavingsCard min={msg.min} max={msg.max} />
            </div>
          )
        }
        if (msg.type === 'cta') {
          return (
            <div key={msg.key} className="msg-cta">
              <button
                className="btn-send btn-send-cta full"
                onClick={() => onCta?.(msg.label)}
                disabled={ctaDisabled}
              >
                {msg.label}
              </button>
            </div>
          )
        }
        return (
          <div key={msg.key} className="msg-user">
            <div className="msg-user-bubble">{msg.text}</div>
          </div>
        )
      })}
    </div>
  )
})
